import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import BottomBar from '../components/BottomBar';
import back from '../assets/icon/back.svg';
import './CompleteTest.css';

const CompleteTest = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const surahParam = searchParams.get('surah');
  const modeParam = searchParams.get('mode') || 'full';
  const startParam = parseInt(searchParams.get('start'), 10);
  const endParam = parseInt(searchParams.get('end'), 10);
  const [ayahs, setAyahs] = useState([]);
  const [order, setOrder] = useState([]); // randomized indices
  const [index, setIndex] = useState(0);
  const [options, setOptions] = useState([]);
  const [selected, setSelected] = useState(null);
  const [result, setResult] = useState(null);
  const [showOptions, setShowOptions] = useState(false);
  const [nextAyahIndex, setNextAyahIndex] = useState(0);
  const [surahComplete, setSurahComplete] = useState(false);



  useEffect(() => {
    if (!surahParam) return;
    fetch(`https://api.alquran.cloud/v1/surah/${surahParam}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.code === 200) {
            let list = data.data.ayahs
            .filter((a) => a.numberInSurah !== 1)
            .map((a) => ({
              number: a.numberInSurah,
              text: a.text,
            }));
            
          if (modeParam === 'range') {
            if (
              !isNaN(startParam) &&
              !isNaN(endParam) &&
              startParam >= 1 &&
              endParam <= data.data.ayahs.length &&
              startParam <= endParam
            ) {
              list = list.filter(
                (a) => a.number >= startParam && a.number <= endParam
              );
            }
          }
          setAyahs(list);
          // create a shuffled list of indices for questions
          const qIndices = shuffle([...Array(Math.max(list.length - 1, 0)).keys()]);
          setOrder(qIndices);
          setIndex(0);
        }
      })
      .catch((err) => console.error(err));
    }, [surahParam, modeParam, startParam, endParam]);

  useEffect(() => {
    if (order.length > 0 && index < order.length) {
    //   generateOptions();
      setNextAyahIndex(0);
      setShowOptions(false);
      setSurahComplete(false);

      generateOptions(0);
    }
  }, [order, index]);
  useEffect(() => {
    if (order.length > 0 && index < order.length) {
        if (order[index] + nextAyahIndex < ayahs.length - 1) {
            generateOptions(nextAyahIndex);
            setSurahComplete(false);
          } else {
            setSurahComplete(true);
          }
    }
}, [nextAyahIndex, order, index, ayahs.length]);


  const shuffle = (arr) => {
    const array = [...arr];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const generateOptions = (offset = nextAyahIndex) => {
    const currentIdx = order[index];
    const correct = ayahs[currentIdx + offset + 1];
    const others = ayahs.filter((_, i) => i !== currentIdx + offset + 1);
    const sampled = shuffle(others).slice(0, 3);
    const opts = shuffle([correct, ...sampled]);
    setOptions(opts);
  };

  const handleAnswer = (opt) => {
    setSelected(opt);
    const currentIdx = order[index];
    if (opt.number === ayahs[currentIdx + nextAyahIndex + 1].number) {
        setResult('correct');
    } else {
      setResult('wrong');
    }
  };
  const isSurahEnd =
  order.length > 0 && order[index] + nextAyahIndex >= ayahs.length - 1;

const handleNextAyah = () => {
  setSelected(null);
  setResult(null);
  setNextAyahIndex((prev) => {
    const val = prev + 1;
    setShowOptions(false);
    return val;
  });
};

  const nextQuestion = () => {
    setSelected(null);
    setResult(null);
    setIndex((prev) => prev + 1);

    setShowOptions(false);
    setNextAyahIndex(0);

  };

  const finishTest = () => {
    navigate('/review-test');
  };

  if (!surahParam || ayahs.length === 0) return null;
  if (index >= order.length) {
    return (
      <div className="ordering-test">
      <div className="test-header">
        <div className="back-icon-container">
          <img
            className="back-icon"
            src={back}
            alt="back"
            onClick={() => navigate(-1)}
          />
        </div>
        <h2 className='test-title title-ordering'>اكمل من قولة تعالى</h2>
      </div>
        
        <p>انتهى الاختبار</p>
        <button className="check-button" onClick={finishTest}>العودة</button>
      </div>
    );
  } 

  return (
    <div className="ordering-test">
      <div className="test-header">
          <div className="back-icon-container">
            <img
              className="back-icon"
              src={back}
              alt="back"
              onClick={() => navigate(-1)}
            />
          </div>
          <h1 className="test-title title-ordering">اكمل من قولة تعالى</h1>
        </div>
      <p className="selected-ayah">
        {ayahs[order[index]].text}
        <span className="ayah-number">{ayahs[order[index]].number}</span>
      </p>
      {[...Array(nextAyahIndex)].map((_, i) => (
        ayahs[order[index] + 1 + i] && (
          <p key={i} className="selected-ayah">
            {ayahs[order[index] + 1 + i].text}
            <span className="ayah-number">{ayahs[order[index] + 1 + i].number}</span>

          </p>
        )
      ))}
      
      {isSurahEnd && (
          <p className="soon-msg">لقد أكملت السورة</p>
        )}
      {showOptions && (
        <div className="ayah-buttons-complete">
          {options.map((o) => (
            <button
              key={o.number}
              onClick={() => handleAnswer(o)}
              disabled={!!selected}
            >
              {o.text}
              {/* <span className="ayah-number">{o.number}</span> */}
            </button>
          ))}
        </div>
      )}
      {result === 'correct' && <p className="correct">إجابة صحيحة</p>}
      {result === 'wrong' && <p className="wrong">إجابة خاطئة</p>}
      <div className="control-buttons-complete">
        <button
            className="check-button-complete"
            onClick={handleNextAyah}
            disabled={isSurahEnd}
        >
          الايه التالية
        </button>

        <button
            className="check-button-complete"
            onClick={() => {
              setSelected(null);
              setResult(null);
              generateOptions(nextAyahIndex);
              setShowOptions(true);
            }}
            disabled={isSurahEnd}
        >
                      اظهر الخيارات
        </button>
        <button className="check-button-complete" onClick={nextQuestion}>
          سؤال جديد
        </button>

        <button className="check-button-complete" onClick={finishTest}>
          انهاء الاختبار
        </button>
      </div>
      {/* <BottomBar /> */}
    </div>
  );
};

export default CompleteTest;